<template>
    <v-dialog v-model="dialog" max-width="500" persistent content-class="rounded-xl">
        <v-card class="rounded-xl">
            <v-card-title class="card-title-modaladddoctype py-4">
                <v-row align="center" class="row-page-modaladddoctype">
                    <v-spacer></v-spacer>
                    <b class="text-headtitle-modaladddoctype">{{ name_modal }}ประเภทเอกสาร</b>
                    <v-spacer></v-spacer>
                    <v-btn icon small color="#ffffff" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-card-text class="pt-7 pb-0 px-6">
                <v-form  ref="form" v-model="valid">
                <v-row align="center" class="row-page-modaladddoctype">
                    <v-col align-self="start" cols="12" sm="4" md="4" lg="4" class="px-0 pb-0">
                        <span class="text-subtitle-modaladddoctype">Tax ID :</span>
                    </v-col>
                    <v-col align-self="center" cols="12" sm="8" md="8" lg="8" class="pa-0">
                        <v-text-field outlined  dense class="search-box-modaladddoctype" color="#1DBC97"
                            background-color="white" v-model="tempData.tax_id"  :rules="[v => !!v && !v.includes(' ') || 'กรุณากรอก Tax ID และห้ามเว้นวรรค']" :disabled="name_modal === 'แก้ไข'">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" class="row-page-modaladddoctype mt-0">
                    <v-col align-self="start" cols="12" sm="4" md="4" lg="4" class="px-0 pb-0">
                        <span class="text-subtitle-modaladddoctype">Document Type ID :</span>
                    </v-col>
                    <v-col align-self="center" cols="12" sm="8" md="8" lg="8" class="pa-0">
                        <v-text-field outlined dense class="search-box-modaladddoctype" color="#1DBC97"
                            background-color="white" v-model="tempData.document_id" :rules="[v => !!v && !v.includes(' ') || 'กรุณากรอก Document type ID และห้ามเว้นวรรค']">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" class="row-page-modaladddoctype mt-0">
                    <v-col align-self="center" cols="12" sm="4" md="4" lg="4" class="pa-0">
                        <span class="text-subtitle-modaladddoctype">หมายเหตุ :</span>
                    </v-col>
                    <v-col align-self="center" cols="12" sm="8" md="8" lg="8" class="pa-0">
                        <v-text-field outlined hide-details dense class="search-box-modaladddoctype" color="#1DBC97" v-model="tempData.remark"
                            background-color="white">
                        </v-text-field>
                    </v-col>
                </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pt-8 pb-5 px-8">
                <v-row align="center" justify="center" class="row-page-modaladddoctype">
                    <v-col align-self="center" cols="6" sm="6" lg="4" md="4" class="pl-0 py-0 pr-5">
                        <v-btn block color="#1DBC97" outlined class="btn-cancon-modaladddoctype"
                            @click="dialog = false">
                            ยกเลิก
                        </v-btn>
                    </v-col>
                    <v-col align-self="center" cols="6" sm="6" lg="4" md="4" class="pr-0 py-0 pl-5">
                        <v-btn :disabled="!valid" block color="#1DBC97" depressed class="white--text btn-cancon-modaladddoctype" @click="saveDocumentType()">
                            ยืนยัน
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from "../EventBus";

export default {
    data: () => ({
        dialog: false,
        name_modal : "",
        json_data_tax_id : {
            tax_id: "",
            document_id: "",
            remark: ""
        },
        tempData: { // ข้อมูลชั่วคราวสำหรับใช้ในฟอร์ม
            tax_id: "",
            document_id: "",
            remark: ""
        },
        valid: false, 
    }),
    mounted() {
        EventBus.$on(
            "FormModalAddDoctye", this.GetModalAddDoctye
        );
    },
    beforeDestroy() {
        EventBus.$off("FormModalAddDoctye")
    },
    methods: {
        GetModalAddDoctye(action,item) {
            if(action == "create"){
                this.name_modal = "เพิ่ม"
                this.tempData = { tax_id: "", document_id: "", remark: "" };
            }else if(action =="update"){
                this.name_modal = "แก้ไข"   
                this.tempData = {...item};          

            }
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.form.resetValidation();
                if (action == "create") {
                    this.$refs.form.reset(); 
                }
            });
        },
        saveDocumentType() {
            const sanitizedData = {
                tax_id: this.tempData.tax_id.trim(),
                document_id: this.tempData.document_id.trim(),
                remark: this.tempData.remark || ""
            };
            let dataJson = {...sanitizedData};
            this.saveDocumentTypeToAPI(dataJson)
        },
        async saveDocumentTypeToAPI(json_data) {
            try {
                if (this.name_modal == "เพิ่ม") {
                    let url = '/petty_cash/api/v1/add_hc_doctype'
                    let { data } = await this.axios.post(this.$api_url + url,json_data ,{ headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") } })
                    if(data.status){
                        this.$swal({
                            backdrop: false,
                            position: 'top-end',
                            width: '353px',
                            title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z" fill="#4CAF1E"/></svg><b class="alert-success-title">เพิ่มสำเร็จ</b>',
                            text: 'เพิ่มประเภทเอกสารเรียบร้อยแล้ว',
                            showCloseButton: true,
                            showConfirmButton: false,
                            timer: 2000,
                            customClass: {
                            container: 'alert-card-block',
                            popup: 'alert-card-success',
                            title: 'alert-title-block-v2',
                            closeButton: 'alert-close-btn',
                            htmlContainer: 'alert-text-box'
                            }
                        })
                        this.dialog = false;
                        EventBus.$emit("FormHcDashBoardAddDoctype");
                    }
                }else if (this.name_modal == "แก้ไข") {
                    let url = '/petty_cash/api/v1/update_hc_doctype'
                    let { data } = await this.axios.put(this.$api_url + url,json_data ,{ headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") } })
                    if(data.status){
                        this.$swal({
                            backdrop: false,
                            position: 'top-end',
                            width: '353px',
                            title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z" fill="#4CAF1E"/></svg><b class="alert-success-title">แก้ไขสำเร็จ</b>',
                            text: 'แก้ไขระเภทเอกสารเรียบร้อยแล้ว',
                            showCloseButton: true,
                            showConfirmButton: false,
                            timer: 2000,
                            customClass: {
                            container: 'alert-card-block',
                            popup: 'alert-card-success',
                            title: 'alert-title-block-v2',
                            closeButton: 'alert-close-btn',
                            htmlContainer: 'alert-text-box'
                            }
                        })
                        this.dialog = false;
                        EventBus.$emit("FormHcDashBoardAddDoctype");
                    }
                }
            } catch (error) {
                console.log(error)
                this.$swal({
                    backdrop: false,
                    position: 'top-end',
                    width: '353px',
                    title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1118_2932)"><path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17H12.01" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 11V14" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg><b class="alert-error-title">เพิ่มไม่สำเร็จ</b>',
                    text: 'กรุณาลองใหม่ในภายหลัง',
                    showCloseButton: true,
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-error',
                    title: 'alert-title-block-v2',
                    closeButton: 'alert-close-btn',
                    htmlContainer: 'alert-text-box'
                    }
                })
                
            }
        }, 
    }
};
</script>

<style>
.row-page-modaladddoctype {
    width: 100%;
    margin: 0%;
}

.card-title-modaladddoctype {
    background: #1dbc97;
    height: 56px;
}

.text-headtitle-modaladddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px !important;
}

.text-subtitle-modaladddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px;
    color: black !important;
}

.search-box-modaladddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important;
}

.search-box-modaladddoctype.v-text-field input {
    line-height: 28px !important;
}

.btn-cancon-modaladddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important;
    height: 40px !important;
    font-weight: 700;
    border-radius: 8px !important;
}

</style>